export enum RequestDataType {
    Demo,
    Support,
    Order,
    ContactUs,
    Customization,
    HelpBusiness,
    Brands,
    Blogging,
    BrandCommunications,
    SportAndEvents,
    CorporateTraining,
    PublicSpeakers,
    Edutainment,
    Other
}